<script>
    export let panel;
    export let selected;
</script>

{#if selected === panel}
    <slot />
{/if}
